"use client";
import Script from 'next/script';
import { logger } from '@/lib/logger';

const Mailchimp = () => {
  return (
    <Script
      id="mcjs"
      strategy="afterInteractive"
      src="/api/mailchimp"
      crossOrigin="anonymous"
      defer
      data-partitioned="true"
      onLoad={() => logger.log("Mailchimp script loaded successfully")}
      onError={(e) => logger.error("Error loading Mailchimp script:", e)}
    />
  );
};

export default Mailchimp;